export default function resize(callback, options = {passive: true}) {
    window.addEventListener('resize', () => {
        callback(window.innerWidth, window.innerHeight)
    }, options)
    callback(window.innerWidth, window.innerHeight)
}

